// extracted by mini-css-extract-plugin
export default {"layout":"x894R__layout","header":"_q_b1__header","headerText":"WxQsm__headerText theme-accent-border","headerLink":"cz5Km__headerLink"};